

// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   FaArrowLeft, 
//   FaAward, 
//   FaCloudUploadAlt, 
//   FaSave, 
//   FaPalette, 
//   FaCalendarAlt, 
//   FaUsers,
//   FaCheckCircle 
// } from 'react-icons/fa';
// import axios from 'axios';

// const BASE_URL = 'https://rvapi.emedha.in/pages/api';

// const CertificateDesigner = () => {
//   const navigate = useNavigate();

//   // 1. Theme Configuration
//   const [selectedTheme, setSelectedTheme] = useState('classic'); 
//   const [selectedBadge, setSelectedBadge] = useState('trophy');

//   // 2. Blueprint Content
//   const [certData, setCertData] = useState({
//     header: 'Certificate of Excellence',
//     title: 'PROUDLY PRESENTED TO',
//     recipientName: 'Sivaji Kumar',
//     prefixText: 'For demonstrating exceptional proficiency in',
//     achievementText: 'for achieving outstanding performance and ranking among the elite top tier in the QuizifyAI Live Arena Evaluation Match.',
//     dateText: 'July 06, 2026',
//     scoreText: 'Score: 940 pts | Rank: #1',
//     footerTitle: 'AUTHORIZED SIGNATURE'
//   });

//   const [logoPreview, setLogoPreview] = useState(null);
//   const [sigPreview, setSignaturePreview] = useState(null);

//   // 3. Event & Session Scope
//   const [userId, setUserId] = useState('');
//   const [eventsList, setEventsList] = useState([]);
//   const [selectedEventId, setSelectedEventId] = useState('');
//   const [selectedEventName, setSelectedEventName] = useState('QuizifyAI Live Evaluation Match');

//   const [sessionsList, setSessionsList] = useState([]);
//   const [selectedRoomPin, setSelectedRoomPin] = useState('');
//   const [isIssuing, setIsIssuing] = useState(false);


//   const [subStatus, setSubStatus] = useState(null);
// const [subLoading, setSubLoading] = useState(true);


// // 1. Check if trial or plan has expired
// const isPlanExpired = (() => {
//   if (!subStatus) return false;
//   return subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired';
// })();

// // 2. Determine allowed template count (allowed_certificate_templates from DB or plan tier)
// const allowedTemplateCount = (() => {
//   if (!subStatus || isPlanExpired) return 0; // Expired = none allowed
  
//   // Use DB value if returned, otherwise check planTier
//   if (subStatus.allowedTemplates !== undefined) {
//     return subStatus.allowedTemplates;
//   }
  
//   const tier = (subStatus.planTier || '').toLowerCase();
//   if (tier === 'gold') return 4;
//   if (tier === 'silver') return 2;
//   if (tier === 'basic' || tier === 'trial') return 1;
//   return 1;
// })();

// const getLockMessage = () => {
//   if (!subStatus) return '';
//   if (subStatus.planStatus === 'trial_expired') {
//     return 'Your 24-hour trial has expired. Upgrade your plan to customize and issue certificates.';
//   }
//   if (subStatus.planStatus === 'expired') {
//     return 'Your subscription plan has expired. Please renew to customize and issue certificates.';
//   }
//   return '';
// };

// const fetchSubStatus = async (uid) => {
//   try {
//     setSubLoading(true);
//     const res = await axios.get(`${BASE_URL}/pages/api/api/subscription/current-status/${uid}`)
//       .catch(() => axios.get(`${BASE_URL}/api/subscription/current-status/${uid}`));
//     if (res.data?.success) {
//       setSubStatus(res.data);
//     }
//   } catch (err) {
//     console.error("Failed to load subscription status:", err);
//   } finally {
//     setSubLoading(false);
//   }
// };

//   // Fetch host events on mount
//   useEffect(() => {
//     const storedUser = sessionStorage.getItem('user');
//     if (storedUser) {
//       const parsedUser = JSON.parse(storedUser);
//       const uid = parsedUser.id || parsedUser.user_id;
//       setUserId(uid);
//       fetchSubStatus(uid);

//       axios.get(`${BASE_URL}/api/events?userId=${uid}`)
//         .then(res => {
//           if (Array.isArray(res.data)) {
//             setEventsList(res.data);
//             const activeEvent = res.data.find(e => e.flag === 1) || res.data[0];
//             if (activeEvent) {
//               setSelectedEventName(activeEvent.name);
//               setSelectedEventId(String(activeEvent.id));
//               fetchSessions(uid, activeEvent.id);
//             }
//           }
//         })
//         .catch(err => console.error("Failed to load designer events:", err));
//     }
//   }, []);

//   const fetchSessions = async (uid, eventId) => {
//     try {
//       const res = await axios.get(`${BASE_URL}/api/analytics/sessions?userId=${uid}&eventId=${eventId}`)
//         .catch(() => axios.get(`${BASE_URL}/analytics/sessions?userId=${uid}&eventId=${eventId}`));

//       if (Array.isArray(res.data)) {
//         setSessionsList(res.data);
//         if (res.data.length > 0) {
//           setSelectedRoomPin(String(res.data[0].room_pin));
//         } else {
//           setSelectedRoomPin('');
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching sessions:", err);
//     }
//   };

//   const handleSelectEvent = (e) => {
//     const eventId = e.target.value;
//     setSelectedEventId(eventId);
//     const match = eventsList.find(ev => String(ev.id) === String(eventId));
//     if (match) {
//       setSelectedEventName(match.name);
//       fetchSessions(userId, match.id);
//     }
//   };

//   const formatSessionDate = (dateStr) => {
//     if (!dateStr) return { date: 'N/A', time: '' };
//     const d = new Date(dateStr);
//     return {
//       date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
//       time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
//     };
//   };

//   // Distinct Theme Geometries
//   const themes = {
//     classic: {
//       layoutVariant: 'centered-traditional',
//       border: '12px double #d4af37',
//       background: '#fffdf6',
//       accentColor: '#d4af37',
//       textColor: '#5c4033',
//       fontFamily: '"Georgia", serif',
//       badgeRibbonColor: '#e21b3c'
//     },
//     modern: {
//       layoutVariant: 'asdependent-split',
//       border: '1px solid rgba(47, 49, 148, 0.1)',
//       background: '#ffffff',
//       accentColor: '#2f3194',
//       textColor: '#0f1137',
//       fontFamily: '"Plus Jakarta Sans", sans-serif',
//       badgeRibbonColor: '#1368ce',
//       sideBlockBg: 'linear-gradient(180deg, #0f1137 0%, #2f3194 100%)'
//     },
//     luxuryDark: {
//       layoutVariant: 'minimal-darkmode',
//       border: '4px solid #d4af37',
//       background: 'radial-gradient(circle at center, #141526 0%, #070814 100%)',
//       accentColor: '#d4af37',
//       textColor: '#ffffff',
//       fontFamily: '"Poppins", sans-serif',
//       badgeRibbonColor: '#f35018',
//       subTextColor: '#a0a5ba'
//     },
//     quizifyBrand: {
//       layoutVariant: 'corporate-clean',
//       border: '3px solid #2f3194',
//       background: 'linear-gradient(180deg, #ffffff 0%, #f1f3f9 100%)',
//       accentColor: '#2f3194',
//       textColor: '#0f1137',
//       fontFamily: '"Plus Jakarta Sans", sans-serif',
//       badgeRibbonColor: '#f35018',
//       showPromo: true
//     }
//   };

//   const handleTextChange = (e) => {
//     const { name, value } = e.target;
//     setCertData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleFileUploader = (e, setPreview) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreview(reader.result); // Base64 data URL
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSaveTemplate = async () => {
//     if (!selectedEventId) {
//       alert("Please select a target live event.");
//       return;
//     }

//     if (!selectedRoomPin) {
//       alert("Please select a match room session.");
//       return;
//     }

//     try {
//       setIsIssuing(true);

//       const payload = {
//         event_id: selectedEventId,
//         room_pin: selectedRoomPin,
//         selectedEventName: selectedEventName,
//         designBlueprint: {
//           themeKey: selectedTheme,
//           badgeStyle: selectedBadge,
//           header: certData.header,
//           title: certData.title,
//           prefixText: certData.prefixText,
//           achievementText: certData.achievementText,
//           dateText: certData.dateText,
//           scoreText: certData.scoreText,
//           footerTitle: certData.footerTitle,
//           logoDataUrl: logoPreview, 
//           sigDataUrl: sigPreview 
//         }
//       };

//       const response = await axios.post(`${BASE_URL}/api/quiz/issue-certificates`, payload)
//         .catch(() => axios.post(`${BASE_URL}/quiz/issue-certificates`, payload));

//       if (response.data?.success) {
//         alert(`Successfully generated and dispatched ${response.data.count || 0} certificates!`);
//         navigate(-1);
//       } else {
//         alert(response.data?.message || 'No eligible participant score records found.');
//       }
//     } catch (err) {
//       console.error("Studio dispatch breakdown:", err);
//       alert('Certificate issue pipeline encountered an error.');
//     } finally {
//       setIsIssuing(false);
//     }
//   };

//   const activeStyle = themes[selectedTheme] || themes.classic;

//   return (
//     <div className="d-flex flex-column min-vh-100" style={{ background: '#f4f5fc', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
      
//       {/* TOP CLEAN WHITE MANAGEMENT BAR */}
//       <div className="bg-white px-4 py-3 d-flex justify-content-between align-items-center shadow-sm" style={{ borderBottom: '1px solid rgba(47, 49, 148, 0.08)' }}>
//         <button onClick={() => navigate(-1)} className="btn btn-light d-flex align-items-center gap-2 rounded-3 text-dark fw-semibold" style={{ fontSize: '13px' }}>
//           <FaArrowLeft /> Back to Dashboard
//         </button>
//         <div className="d-flex align-items-center gap-2">
//           <FaAward size={22} style={{ color: '#2f3194' }} />
//           <h5 className="m-0 fw-bold" style={{ fontSize: '16px', color: '#0f1137' }}>Credential Customizer Studio</h5>
//         </div>
//         {/* <button 
//           onClick={handleSaveTemplate} 
//           disabled={isIssuing} 
//           className="btn text-white fw-bold d-flex align-items-center gap-2 px-4" 
//           style={{ 
//             backgroundColor: isIssuing ? '#a0aec0' : '#f35018', 
//             borderRadius: '10px', 
//             fontSize: '13px', 
//             border: 'none',
//             cursor: isIssuing ? 'not-allowed' : 'pointer'
//           }}
//         >
//           {isIssuing ? (
//             <>
//               <div className="spinner-border spinner-border-sm text-light" role="status"></div>
//               <span>Issuing Certificates...</span>
//             </>
//           ) : (
//             <>
//               <FaSave />
//               <span>Save &amp; Issue Certificates 🚀</span>
//             </>
//           )}
//         </button> */}
//         <button 
//   onClick={() => {
//     if (isPlanExpired) {
//       alert(getLockMessage());
//       return;
//     }
//     handleSaveTemplate();
//   }} 
//   disabled={isIssuing || isPlanExpired} 
//   className="btn text-white fw-bold d-flex align-items-center gap-2 px-4" 
//   style={{ 
//     backgroundColor: (isIssuing || isPlanExpired) ? '#94a3b8' : '#f35018', 
//     borderRadius: '10px', 
//     fontSize: '13px', 
//     border: 'none', 
//     cursor: (isIssuing || isPlanExpired) ? 'not-allowed' : 'pointer',
//     opacity: isPlanExpired ? 0.65 : 1
//   }}
//   title={isPlanExpired ? getLockMessage() : "Save & Issue"}
// >
//   {isIssuing ? (
//     <>
//       <div className="spinner-border spinner-border-sm text-light" role="status"></div>
//       <span>Issuing Certificates...</span>
//     </>
//   ) : isPlanExpired ? (
//     <>
//       <span>🔒 Plan Expired</span>
//     </>
//   ) : (
//     <>
//       <FaSave />
//       <span>Save &amp; Issue Certificates 🚀</span>
//     </>
//   )}
// </button>
//       </div>

//       {/* MASTER TWO-COLUMN CONTENT GRID */}
//       <div className="flex-grow-1 row g-0">
        
//         {/* LEFT CONTROL SIDEBAR PANEL */}
//         <div className="col-12 col-lg-4 bg-white p-4 shadow-sm" style={{ maxHeight: 'calc(100vh - 70px)', overflowY: 'auto', borderRight: '1px solid rgba(47, 49, 148, 0.08)' }}>
          
//           {/* SECTION 1: EVENT & SESSION SCOPE */}
//           <div className="mb-4">
//             <label className="form-label small fw-bold text-uppercase text-muted tracking-wide mb-1">
//               1. Target Event
//             </label>
//             <select 
//               className="form-select mb-3" 
//               style={{ borderRadius: '8px', fontSize: '13px' }}
//               value={selectedEventId}
//               onChange={handleSelectEvent}
//             >
//               <option value="">-- Choose Event Scope --</option>
//               {eventsList.map((ev) => (
//                 <option key={ev.id} value={ev.id}>{ev.name} (ID: #{ev.id})</option>
//               ))}
//             </select>

//             <label className="form-label small fw-bold text-uppercase text-muted tracking-wide mb-1">
//               2. Target Match Session ({sessionsList.length})
//             </label>
//             {sessionsList.length === 0 ? (
//               <div className="p-3 text-center border rounded-3 bg-light text-muted small">
//                 No recorded match sessions found for this event.
//               </div>
//             ) : (
//               <div className="d-flex flex-column gap-2" style={{ maxHeight: '160px', overflowY: 'auto' }}>
//                 {sessionsList.map((s) => {
//                   const isSelected = selectedRoomPin === String(s.room_pin);
//                   const { date, time } = formatSessionDate(s.created_at);
//                   return (
//                     <div 
//                       key={s.id}
//                       onClick={() => setSelectedRoomPin(String(s.room_pin))}
//                       style={{
//                         padding: '10px 14px',
//                         borderRadius: '10px',
//                         border: isSelected ? '2px solid #f35018' : '1px solid #e2e8f0',
//                         backgroundColor: isSelected ? '#fffaf8' : '#fafbfc',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center'
//                       }}
//                     >
//                       <div>
//                         <span style={{ fontSize: '12px', fontWeight: '700', color: isSelected ? '#f35018' : '#0f1137', display: 'block' }}>
//                           PIN #{s.room_pin}
//                         </span>
//                         <small style={{ color: '#64748b', fontSize: '10px' }}>
//                           <FaCalendarAlt style={{ marginRight: '4px' }} />{date} • {time}
//                         </small>
//                       </div>
//                       <div className="d-flex align-items-center gap-2">
//                         <small style={{ fontWeight: '700', color: '#2f3194', fontSize: '11px' }}>
//                           <FaUsers style={{ marginRight: '4px' }} />{s.total_participants || 0}
//                         </small>
//                         {isSelected && <FaCheckCircle color="#f35018" size={14} />}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//           </div>

//           <hr className="my-3" style={{ opacity: 0.08 }} />

//           {/* SECTION 2: TEMPLATE LAYOUT THEME */}
//           {/* <div className="mb-4">
//             <label className="form-label small fw-bold text-uppercase text-muted tracking-wide d-flex align-items-center gap-2 mb-2">
//               <FaPalette /> 3. Layout Style Theme
//             </label>
//             <div className="d-flex flex-wrap gap-2">
//               {[
//                 { key: 'classic', label: 'Classic Gold' },
//                 { key: 'modern', label: 'Modern Navy' },
//                 { key: 'luxuryDark', label: 'Luxury Dark' },
//                 { key: 'quizifyBrand', label: 'Quizify Brand' }
//               ].map(themeItem => (
//                 <button 
//                   key={themeItem.key} 
//                   type="button"
//                   onClick={() => setSelectedTheme(themeItem.key)} 
//                   className="btn py-2 fw-bold text-capitalize rounded-3 flex-grow-1" 
//                   style={{
//                     border: selectedTheme === themeItem.key ? '2px solid #2f3194' : '1px solid rgba(0,0,0,0.1)',
//                     background: selectedTheme === themeItem.key ? 'rgba(47,49,148,0.05)' : '#fff',
//                     color: selectedTheme === themeItem.key ? '#2f3194' : '#6c757d',
//                     fontSize: '12px'
//                   }}
//                 >
//                   {themeItem.label}
//                 </button>
//               ))}
//             </div>
//           </div> */}


//           {/* SECTION 2: TEMPLATE LAYOUT THEME */}
// <div className="mb-4">
//   <div className="d-flex justify-content-between align-items-center mb-2">
//     <label className="form-label small fw-bold text-uppercase text-muted tracking-wide d-flex align-items-center gap-2 m-0">
//       <FaPalette /> 3. Layout Style Theme
//     </label>
//     <span 
//       className="badge rounded-pill px-2.5 py-1"
//       style={{ 
//         fontSize: '11px',
//         backgroundColor: isPlanExpired ? '#fee2e2' : 'rgba(47, 49, 148, 0.08)',
//         color: isPlanExpired ? '#b91c1c' : '#2f3194',
//         border: isPlanExpired ? '1px solid #fca5a5' : 'none'
//       }}
//     >
//       {isPlanExpired 
//         ? 'Plan Expired (0 Enabled)' 
//         : `Available: ${allowedTemplateCount} of 4 Templates`}
//     </span>
//   </div>

//   {/* Expired Plan Banner */}
//   {isPlanExpired && (
//     <div className="alert alert-danger py-2 px-3 small rounded-3 mb-3 d-flex justify-content-between align-items-center">
//       <span>⚠️ {getLockMessage()}</span>
//       <button 
//         type="button" 
//         onClick={() => navigate('/dashboard')} 
//         className="btn btn-sm btn-danger fw-bold py-0 px-2"
//         style={{ fontSize: '11px', borderRadius: '6px' }}
//       >
//         Upgrade
//       </button>
//     </div>
//   )}

//   <div className="d-flex flex-wrap gap-2">
//     {[
//       { key: 'classic', label: 'Classic Gold' },
//       { key: 'modern', label: 'Modern Navy' },
//       { key: 'luxuryDark', label: 'Luxury Dark' },
//       { key: 'quizifyBrand', label: 'Quizify Brand' }
//     ].map((themeItem, index) => {
//       // Disabled if plan is expired OR index exceeds allowed count for this tier
//       const isLocked = isPlanExpired || index >= allowedTemplateCount;

//       return (
//         <button 
//           key={themeItem.key} 
//           type="button"
//           disabled={isLocked}
//           onClick={() => setSelectedTheme(themeItem.key)} 
//           className="btn py-2 fw-bold text-capitalize rounded-3 flex-grow-1 position-relative" 
//           style={{
//             border: selectedTheme === themeItem.key && !isLocked 
//               ? '2px solid #2f3194' 
//               : '1px solid rgba(0,0,0,0.1)',
//             background: isLocked 
//               ? '#f1f5f9' 
//               : selectedTheme === themeItem.key 
//               ? 'rgba(47,49,148,0.05)' 
//               : '#fff',
//             color: isLocked 
//               ? '#94a3b8' 
//               : selectedTheme === themeItem.key 
//               ? '#2f3194' 
//               : '#6c757d',
//             fontSize: '12px',
//             cursor: isLocked ? 'not-allowed' : 'pointer',
//             opacity: isLocked ? 0.6 : 1
//           }}
//           title={isLocked ? (isPlanExpired ? getLockMessage() : `Upgrade your plan to unlock ${themeItem.label}`) : themeItem.label}
//         >
//           {isLocked && <span style={{ marginRight: '4px' }}>🔒</span>}
//           {themeItem.label}
//         </button>
//       );
//     })}
//   </div>
// </div>

//           {/* SECTION 3: HEADER ASSETS & EMBLEM */}
//           <h6 className="fw-bold mb-3" style={{ color: '#2f3194', fontSize: '13px' }}>[STAGE 1] HEADER &amp; LOGO ASSETS</h6>
          
//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Upload Organization Brand Logo</label>
//             <div className="position-relative text-center border p-3 rounded-3" style={{ background: '#fafbfc', borderStyle: 'dashed', cursor: 'pointer' }}>
//               <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setLogoPreview)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
//               <FaCloudUploadAlt size={22} className="text-muted mb-1" />
//               <span className="d-block small text-muted" style={{ fontSize: '11px' }}>
//                 {logoPreview ? 'Change Logo Image' : 'Select Image File'}
//               </span>
//             </div>
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-bold text-uppercase text-muted tracking-wide mb-2">
//               🏅 Header Seal Emblem
//             </label>
//             <div className="d-flex flex-wrap gap-1">
//               {[
//                 { key: 'trophy', label: '🏆 Trophy' },
//                 { key: 'starShield', label: '⭐ Star' },
//                 { key: 'ribbon', label: '🏅 Medal' },
//                 { key: 'modernSeal', label: '👑 Crest' }
//               ].map(badgeItem => (
//                 <button
//                   key={badgeItem.key}
//                   type="button"
//                   onClick={() => setSelectedBadge(badgeItem.key)}
//                   className="btn py-1.5 fw-bold rounded-3 flex-grow-1"
//                   style={{
//                     border: selectedBadge === badgeItem.key ? '2px solid #f35018' : '1px solid rgba(0,0,0,0.1)',
//                     background: selectedBadge === badgeItem.key ? 'rgba(243,80,24,0.05)' : '#fff',
//                     color: selectedBadge === badgeItem.key ? '#f35018' : '#6c757d',
//                     fontSize: '11px'
//                   }}
//                 >
//                   {badgeItem.label}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Upper Header Heading</label>
//             <input type="text" className="form-control" name="header" value={certData.header} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
//           </div>

//           <hr className="my-4" style={{ opacity: 0.08 }} />

//           {/* SECTION 4: BODY COPY & EDITABLE PREFIX */}
//           <h6 className="fw-bold mb-3" style={{ color: '#2f3194', fontSize: '13px' }}>[STAGE 2] MAIN BODY COPY</h6>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Presentation Title Phrase</label>
//             <input type="text" className="form-control" name="title" value={certData.title} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Recipient Name (Preview Display)</label>
//             <input type="text" className="form-control" name="recipientName" value={certData.recipientName} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px', fontWeight: 'bold' }} />
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Introductory Prefix Phrase</label>
//             <input type="text" className="form-control" name="prefixText" value={certData.prefixText} onChange={handleTextChange} placeholder="e.g. For demonstrating exceptional proficiency in" style={{ borderRadius: '8px', fontSize: '13px' }} />
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Achievement Description Continuation</label>
//             <textarea className="form-control" rows="2" name="achievementText" value={certData.achievementText} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px', lineHeight: '1.4' }} />
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Score / Placement Badge Text</label>
//             <input type="text" className="form-control" name="scoreText" value={certData.scoreText} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
//           </div>

//           <hr className="my-4" style={{ opacity: 0.08 }} />

//           {/* SECTION 5: FOOTER & SIGNATURES */}
//           <h6 className="fw-bold mb-3" style={{ color: '#2f3194', fontSize: '13px' }}>[STAGE 3] LOWER FOOTER &amp; SIGNATURES</h6>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Date Issued Text</label>
//             <input type="text" className="form-control" name="dateText" value={certData.dateText} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Authorized Signature Image (PNG)</label>
//             <div className="position-relative text-center border p-3 rounded-3" style={{ background: '#fafbfc', borderStyle: 'dashed', cursor: 'pointer' }}>
//               <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setSignaturePreview)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
//               <FaCloudUploadAlt size={22} className="text-muted mb-1" />
//               <span className="d-block small text-muted" style={{ fontSize: '11px' }}>
//                 {sigPreview ? 'Change Signature Image' : 'Upload Signature'}
//               </span>
//             </div>
//           </div>

//           <div className="mb-3">
//             <label className="form-label small fw-semibold text-muted">Signatory Title Description</label>
//             <input type="text" className="form-control" name="footerTitle" value={certData.footerTitle} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
//           </div>

//         </div>

//         {/* RIGHT LIVE CANVAS ARTBOARD DISPLAY */}
//         <div className="col-12 col-lg-8 d-flex align-items-center justify-content-center p-4" style={{ background: '#eef0fa', overflowX: 'auto' }}>
          
//           <div className="shadow-2xl position-relative p-5 animate-fade-in" style={{
//             width: '840px',
//             height: '595px', 
//             background: activeStyle.background,
//             border: activeStyle.border,
//             fontFamily: activeStyle.fontFamily,
//             boxShadow: '0 30px 60px rgba(15, 17, 55, 0.12)',
//             transition: 'all 0.4s ease',
//             boxSizing: 'border-box',
//             color: activeStyle.textColor
//           }}>
            
//             {/* Graphic Corner Accents */}
//             <div style={{ position: 'absolute', top: '20px', left: '20px', width: '40px', height: '40px', borderTop: `3px solid ${activeStyle.accentColor}`, borderLeft: `3px solid ${activeStyle.accentColor}` }} />
//             <div style={{ position: 'absolute', bottom: '20px', right: '20px', width: '40px', height: '40px', borderBottom: `3px solid ${activeStyle.accentColor}`, borderRight: `3px solid ${activeStyle.accentColor}` }} />

//             {/* Top Decorative Band */}
//             <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '220px', height: '18px', background: activeStyle.accentColor, borderRadius: '0 0 12px 12px', opacity: 0.85 }} />

//             {/* Header Row */}
//             <div className="position-relative d-flex justify-content-between align-items-center mb-2" style={{ minHeight: '55px' }}>
//               <div style={{ zIndex: 2 }}>
//                 {logoPreview ? (
//                   <img src={logoPreview} alt="Logo" style={{ maxHeight: '45px', maxWidth: '80px', objectFit: 'contain' }} />
//                 ) : (
//                   <div className="border rounded d-flex align-items-center justify-content-center text-muted" style={{ width: '45px', height: '35px', background: 'rgba(56, 56, 56, 0.02)', borderStyle: 'dashed', fontSize: '9px' }}>Logo</div>
//                 )}
//               </div>

//               {/* Centered Crest Badge */}
//               <div className="position-absolute d-flex flex-column align-items-center justify-content-center shadow-sm" style={{ 
//                 top: '50%',
//                 left: '50%',
//                 transform: 'translate(-50%, -50%)',
//                 background: '#ffffff', 
//                 border: `2px solid ${activeStyle.accentColor}`, 
//                 borderRadius: '50%', 
//                 width: '52px', 
//                 height: '52px', 
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//                 zIndex: 1
//               }}>
//                 <span style={{ fontSize: '24px', lineHeight: '1' }}>
//                   {selectedBadge === 'trophy' && '🏆'}
//                   {selectedBadge === 'starShield' && '⭐'}
//                   {selectedBadge === 'ribbon' && '🏅'}
//                   {selectedBadge === 'modernSeal' && '👑'}
//                 </span>
//               </div>

//               <div style={{ fontSize: '11px', fontWeight: 'bold', color: activeStyle.accentColor, letterSpacing: '0.5px', zIndex: 2 }}>
//                 SECURE VERIFIED CREDENTIAL
//               </div>
//             </div>

//             {/* Main Body Typography */}
//             <div className="text-center mt-3">
//               <h2 className="fw-bold tracking-wide mb-1" style={{ color: activeStyle.accentColor, fontSize: '30px', textTransform: 'uppercase' }}>
//                 {certData.header}
//               </h2>
//               <h6 className="tracking-widest mb-3 fw-bold opacity-75" style={{ fontSize: '11px', letterSpacing: '2px', color: activeStyle.textColor }}>
//                 {certData.title}
//               </h6>
              
//               <h1 className="my-2 style-italic fw-extrabold" style={{ fontStyle: 'italic', fontSize: '40px', borderBottom: `2px solid ${activeStyle.accentColor}`, display: 'inline-block', padding: '0 30px', color: activeStyle.textColor }}>
//                 {certData.recipientName}
//               </h1>

//               <p className="mx-auto mt-3 opacity-90" style={{ fontSize: '14px', maxWidth: '640px', lineHeight: '1.6', color: activeStyle.textColor }}>
//                 {certData.prefixText} <strong style={{ color: activeStyle.accentColor }}>{selectedEventName}</strong> {certData.achievementText}
//               </p>

//               <div className="mt-2 px-4 py-1.5 rounded-pill fw-bold" style={{ 
//                 background: selectedTheme === 'luxuryDark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.03)', 
//                 border: `1px solid ${activeStyle.accentColor}`,
//                 display: 'inline-block', 
//                 fontSize: '13px', 
//                 color: activeStyle.textColor
//               }}>
//                 {certData.scoreText}
//               </div>
//             </div>

//             {/* Footer Row */}
//             <div className="position-absolute bottom-0 start-0 w-100 px-5 d-flex align-items-end justify-content-between" style={{ marginBottom: selectedTheme === 'quizifyBrand' || activeStyle.showPromo ? '52px' : '38px' }}>
              
//               <div className="text-center" style={{ width: '220px' }}>
//                 <span className="d-block border-bottom pb-1 fw-bold" style={{ fontSize: '14px', color: activeStyle.textColor, borderColor: 'rgba(0,0,0,0.15)' }}>
//                   {certData.dateText}
//                 </span>
//                 <small className="d-block mt-1 fw-bold opacity-60" style={{ fontSize: '9px', letterSpacing: '0.5px' }}>
//                   DATE ISSUED
//                 </small>
//               </div>
              
//               {/* Rosette Ribbon */}
//               <div className="d-flex justify-content-center align-items-center" style={{ width: '120px', height: '110px', marginBottom: '-12px' }}>
//                 <div className="position-relative" style={{ width: '80px', height: '110px' }}>
//                   <div style={{
//                     position: 'absolute',
//                     bottom: '4px',
//                     left: '12px',
//                     width: '24px',
//                     height: '62px',
//                     background: `linear-gradient(90deg, ${activeStyle.badgeRibbonColor} 0%, rgba(0,0,0,0.22) 100%)`,
//                     clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 50% 82%, 0% 100%)',
//                     transform: 'rotate(7deg)',
//                     border: '1px solid rgba(255,255,255,0.15)'
//                   }} />
//                   <div style={{
//                     position: 'absolute',
//                     bottom: '4px',
//                     right: '12px',
//                     width: '24px',
//                     height: '62px',
//                     background: `linear-gradient(90deg, rgba(0,0,0,0.22) 0%, ${activeStyle.badgeRibbonColor} 100%)`,
//                     clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 50% 82%, 0% 100%)',
//                     transform: 'rotate(-7deg)',
//                     border: '1px solid rgba(255,255,255,0.15)'
//                   }} />
//                   <div className="shadow-lg" style={{
//                     position: 'absolute',
//                     top: 0,
//                     left: '4px',
//                     width: '72px',
//                     height: '72px',
//                     borderRadius: '50%',
//                     background: activeStyle.badgeRibbonColor,
//                     border: '3px dotted rgba(255,255,255,0.38)',
//                     boxShadow: '0 6px 14px rgba(0,0,0,0.22)'
//                   }} />
//                   <div className="d-flex align-items-center justify-content-center" style={{
//                     position: 'absolute',
//                     top: '7px',
//                     left: '11px',
//                     width: '58px',
//                     height: '58px',
//                     borderRadius: '50%',
//                     background: 'linear-gradient(135deg, #ffe066 0%, #d4af37 40%, #aa7c11 70%, #ffe066 100%)',
//                     border: '2px solid #ffffff',
//                     boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.28)'
//                   }}>
//                     <span style={{ fontSize: '20px' }}>🏅</span>
//                   </div>
//                 </div>
//               </div>

//               <div className="text-center" style={{ width: '220px' }}>
//                 <div style={{ height: '42px', marginBottom: '5px' }}>
//                   {sigPreview && <img src={sigPreview} alt="Signature" style={{ maxHeight: '42px', objectFit: 'contain' }} />}
//                 </div>
//                 <span className="d-block border-top pt-1 fw-bold opacity-75" style={{ fontSize: '9px', letterSpacing: '0.5px', borderTop: '1px solid rgba(0,0,0,0.15)', color: activeStyle.textColor }}>
//                   {certData.footerTitle}
//                 </span>
//               </div>

//             </div>

//             {/* Brand Promotional Bar */}
//             {(selectedTheme === 'quizifyBrand' || activeStyle.showPromo) && (
//               <div className="position-absolute bottom-0 start-0 w-100 text-center py-2" style={{ 
//                 background: 'linear-gradient(90deg, #0f1137 0%, #2f3194 100%)', 
//                 color: '#ffffff', 
//                 fontSize: '10px', 
//                 fontWeight: '600',
//                 letterSpacing: '0.5px',
//                 borderTop: '1px solid rgba(255,255,255,0.1)'
//               }}>
//                 Powered &amp; Verified by <span style={{ color: '#63decc', fontWeight: '800' }}>Quizifyai.in</span> — Next-Gen AI Examination Arena Suite
//               </div>
//             )}

//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default CertificateDesigner;




import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaArrowLeft, 
  FaAward, 
  FaCloudUploadAlt, 
  FaSave, 
  FaPalette, 
  FaCalendarAlt, 
  FaUsers,
  FaCheckCircle 
} from 'react-icons/fa';
import axios from 'axios';

const BASE_URL = 'https://rvapi.emedha.in/pages/api';

const CertificateDesigner = () => {
  const navigate = useNavigate();

  // 1. Theme Configuration
  const [selectedTheme, setSelectedTheme] = useState('classic'); 
  const [selectedBadge, setSelectedBadge] = useState('trophy');
  const [logoWidth, setLogoWidth] = useState(120);

// 2. Background Watermark Image & Opacity Controls
const [bgImagePreview, setBgImagePreview] = useState(null);
const [bgOpacity, setBgOpacity] = useState(0.20); // 0.05 to 1.0
const [bgSize, setBgSize] = useState(560); // 300px to 800px

// 3. Signer 1, 2, 3 Photos & Names
const [sig1Photo, setSig1Photo] = useState(null);
const [sig2Photo, setSig2Photo] = useState(null);
const [sig3Photo, setSig3Photo] = useState(null);



  // 2. Blueprint Content
  const [certData, setCertData] = useState({
    header: 'Certificate of Excellence',
    title: 'PROUDLY PRESENTED TO',
    recipientName: 'Sivaji Kumar',
    prefixText: 'For demonstrating exceptional proficiency in',
    achievementText: 'for achieving outstanding performance and ranking among the elite top tier in the QuizifyAI Live Arena Evaluation Match.',
    dateText: 'July 06, 2026',
    scoreText: 'Score: 940 pts | Rank: #1',
    signerName1: '',
    footerTitle: 'AUTHORIZED SIGNATURE', // Signature 1 Title
    signerName2: '',
    footerTitle2: 'CO-ORDINATOR',        // Signature 2 Title (Optional)
    signerName3: '',
    footerTitle3: 'DIRECTOR / PRINCIPAL' // Signature 3 Title (Optional)
  });

  const [logoPreview, setLogoPreview] = useState(null);
  const [sigPreview, setSignaturePreview] = useState(null);

  const [sig1Preview, setSig1Preview] = useState(null);
  const [sig2Preview, setSig2Preview] = useState(null);
  const [sig3Preview, setSig3Preview] = useState(null);

  // 3. Event & Session Scope
  const [userId, setUserId] = useState('');
  const [eventsList, setEventsList] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState('');
  const [selectedEventName, setSelectedEventName] = useState('QuizifyAI Live Evaluation Match');

  const [sessionsList, setSessionsList] = useState([]);
  const [selectedRoomPin, setSelectedRoomPin] = useState('');
  const [isIssuing, setIsIssuing] = useState(false);


  const [selectedSessionType, setSelectedSessionType] = useState('live');


  const [subStatus, setSubStatus] = useState(null);
const [subLoading, setSubLoading] = useState(true);


// 1. Check if trial or plan has expired
const isPlanExpired = (() => {
  if (!subStatus) return false;
  return subStatus.planStatus === 'trial_expired' || subStatus.planStatus === 'expired';
})();

// 2. Determine allowed template count (allowed_certificate_templates from DB or plan tier)
const allowedTemplateCount = (() => {
  if (!subStatus || isPlanExpired) return 0; // Expired = none allowed
  
  // Use DB value if returned, otherwise check planTier
  if (subStatus.allowedTemplates !== undefined) {
    return subStatus.allowedTemplates;
  }
  
  const tier = (subStatus.planTier || '').toLowerCase();
  if (tier === 'platinum') return 4;
  if (tier === 'gold') return 3;
  if (tier === 'silver') return 2;
  if (tier === 'basic' || tier === 'trial') return 1;
  return 1;
})();

const getLockMessage = () => {
  if (!subStatus) return '';
  if (subStatus.planStatus === 'trial_expired') {
    return 'Your 7days trial has expired. Upgrade your plan to customize and issue certificates.';
  }
  if (subStatus.planStatus === 'expired') {
    return 'Your subscription plan has expired. Please renew to customize and issue certificates.';
  }
  return '';
};

const fetchSubStatus = async (uid) => {
  try {
    setSubLoading(true);
    const res = await axios.get(`${BASE_URL}/pages/api/api/subscription/current-status/${uid}`)
      .catch(() => axios.get(`${BASE_URL}/api/subscription/current-status/${uid}`));
    if (res.data?.success) {
      setSubStatus(res.data);
    }
  } catch (err) {
    console.error("Failed to load subscription status:", err);
  } finally {
    setSubLoading(false);
  }
};

  // Fetch host events on mount
  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      const uid = parsedUser.id || parsedUser.user_id;
      setUserId(uid);
      fetchSubStatus(uid);

      axios.get(`${BASE_URL}/api/events?userId=${uid}`)
        .then(res => {
          if (Array.isArray(res.data)) {
            setEventsList(res.data);
            const activeEvent = res.data.find(e => e.flag === 1) || res.data[0];
            if (activeEvent) {
              setSelectedEventName(activeEvent.name);
              setSelectedEventId(String(activeEvent.id));
              fetchSessions(uid, activeEvent.id);
            }
          }
        })
        .catch(err => console.error("Failed to load designer events:", err));
    }
  }, []);

  const fetchSessions = async (uid, eventId) => {
    try {
      const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/analytics/sessions?userId=${uid}&eventId=${eventId}`)
        .catch(() => axios.get(`https://rvapi.emedha.in/pages/api/api/analytics/sessions?userId=${uid}&eventId=${eventId}`));

      if (Array.isArray(res.data)) {
        setSessionsList(res.data);
        if (res.data.length > 0) {
          setSelectedRoomPin(String(res.data[0].room_pin));
          setSelectedSessionType(res.data[0].session_type || 'live');
        } else {
          setSelectedRoomPin('');
          setSelectedSessionType('live');
        }
      }
    } catch (err) {
      console.error("Error fetching sessions:", err);
    }
  };

  const handleSelectEvent = (e) => {
    const eventId = e.target.value;
    setSelectedEventId(eventId);
    const match = eventsList.find(ev => String(ev.id) === String(eventId));
    if (match) {
      setSelectedEventName(match.name);
      fetchSessions(userId, match.id);
    }
  };

  const formatSessionDate = (dateStr) => {
    if (!dateStr) return { date: 'N/A', time: '' };
    const d = new Date(dateStr);
    return {
      date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
    };
  };

  // Distinct Theme Geometries
  const themes = {
    classic: {
      layoutVariant: 'centered-traditional',
      border: '12px double #d4af37',
      background: '#fffdf6',
      accentColor: '#d4af37',
      textColor: '#5c4033',
      fontFamily: '"Georgia", serif',
      badgeRibbonColor: '#e21b3c'
    },
    modern: {
      layoutVariant: 'asdependent-split',
      border: '1px solid rgba(47, 49, 148, 0.1)',
      background: '#ffffff',
      accentColor: '#2f3194',
      textColor: '#0f1137',
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      badgeRibbonColor: '#1368ce',
      sideBlockBg: 'linear-gradient(180deg, #0f1137 0%, #2f3194 100%)'
    },
    luxuryDark: {
      layoutVariant: 'minimal-darkmode',
      border: '4px solid #d4af37',
      background: 'radial-gradient(circle at center, #141526 0%, #070814 100%)',
      accentColor: '#d4af37',
      textColor: '#ffffff',
      fontFamily: '"Poppins", sans-serif',
      badgeRibbonColor: '#f35018',
      subTextColor: '#a0a5ba'
    },
    quizifyBrand: {
      layoutVariant: 'corporate-clean',
      border: '3px solid #2f3194',
      background: 'linear-gradient(180deg, #ffffff 0%, #f1f3f9 100%)',
      accentColor: '#2f3194',
      textColor: '#0f1137',
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      badgeRibbonColor: '#f35018',
      showPromo: true
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setCertData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileUploader = (e, setPreview) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result); // Base64 data URL
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveTemplate = async () => {
    if (!selectedEventId) {
      alert("Please select a target live event.");
      return;
    }

    if (!selectedRoomPin) {
      alert("Please select a match room session.");
      return;
    }

    try {
      setIsIssuing(true);
const uploadedSignatures = [
        { photoUrl: sig1Photo, sigDataUrl: sig1Preview, name: certData.signerName1, designation: certData.footerTitle },
        { photoUrl: sig2Photo, sigDataUrl: sig2Preview, name: certData.signerName2, designation: certData.footerTitle2 },
        { photoUrl: sig3Photo, sigDataUrl: sig3Preview, name: certData.signerName3, designation: certData.footerTitle3 }
      ].filter(s => s.photoUrl || s.sigDataUrl || (s.name && s.name.trim()) || (s.designation && s.designation.trim()));

      if (uploadedSignatures.length === 0) {
        uploadedSignatures.push({
          photoUrl: null,
          sigDataUrl: null,
          name: '',
          designation: certData.footerTitle || 'AUTHORIZED SIGNATURE'
        });
      }
      
      // Signature 1
      // if (sig1Preview) {
      //   uploadedSignatures.push({ sigDataUrl: sig1Preview, title: certData.footerTitle || 'AUTHORIZED SIGNATURE' });
      // }
      // // Signature 2
      // if (sig2Preview) {
      //   uploadedSignatures.push({ sigDataUrl: sig2Preview, title: certData.footerTitle2 || 'CO-ORDINATOR' });
      // }
      // // Signature 3
      // if (sig3Preview) {
      //   uploadedSignatures.push({ sigDataUrl: sig3Preview, title: certData.footerTitle3 || 'DIRECTOR / PRINCIPAL' });
      // }

      // if (uploadedSignatures.length === 0) {
      //   uploadedSignatures.push({ sigDataUrl: null, title: certData.footerTitle || 'AUTHORIZED SIGNATURE' });
      // }

      const payload = {
        event_id: selectedEventId,
        room_pin: selectedRoomPin,
        session_type: selectedSessionType,
        selectedEventName: selectedEventName,
        designBlueprint: {
          themeKey: selectedTheme,
          badgeStyle: selectedBadge,
          header: certData.header,
          title: certData.title,
          prefixText: certData.prefixText,
          achievementText: certData.achievementText,
          dateText: certData.dateText,
          scoreText: certData.scoreText,
          footerTitle: certData.footerTitle,
          logoDataUrl: logoPreview, 
          logoWidth: logoWidth,
          bgWatermarkUrl: bgImagePreview,
    bgOpacity: bgOpacity,
    bgSize: bgSize,
       signatures: uploadedSignatures, 
   
        }
      };

      const response = await axios.post(`https://api.emedhatechnologies.com/quiz/api/quiz/issue-certificates`, payload)
        .catch(() => axios.post(`https://api.emedhatechnologies.com/quiz/api/quiz/issue-certificates`, payload));

      if (response.data?.success) {
        alert(`Successfully generated and dispatched ${response.data.count || 0} certificates!`);
        navigate(-1);
      } else {
        alert(response.data?.message || 'No eligible participant score records found.');
      }
    } catch (err) {
      console.error("Studio dispatch breakdown:", err);
      alert('Certificate issue pipeline encountered an error.');
    } finally {
      setIsIssuing(false);
    }
  };

  const activeStyle = themes[selectedTheme] || themes.classic;

  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: '#f4f5fc', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
      
      {/* TOP CLEAN WHITE MANAGEMENT BAR */}
      <div className="bg-white px-4 py-3 d-flex justify-content-between align-items-center shadow-sm" style={{ borderBottom: '1px solid rgba(47, 49, 148, 0.08)' }}>
        <button onClick={() => navigate(-1)} className="btn btn-light d-flex align-items-center gap-2 rounded-3 text-dark fw-semibold" style={{ fontSize: '13px' }}>
          <FaArrowLeft /> Back to Dashboard
        </button>
        <div className="d-flex align-items-center gap-2">
          <FaAward size={22} style={{ color: '#2f3194' }} />
          <h5 className="m-0 fw-bold" style={{ fontSize: '16px', color: '#0f1137' }}>Credential Customizer Studio</h5>
        </div>
        {/* <button 
          onClick={handleSaveTemplate} 
          disabled={isIssuing} 
          className="btn text-white fw-bold d-flex align-items-center gap-2 px-4" 
          style={{ 
            backgroundColor: isIssuing ? '#a0aec0' : '#f35018', 
            borderRadius: '10px', 
            fontSize: '13px', 
            border: 'none',
            cursor: isIssuing ? 'not-allowed' : 'pointer'
          }}
        >
          {isIssuing ? (
            <>
              <div className="spinner-border spinner-border-sm text-light" role="status"></div>
              <span>Issuing Certificates...</span>
            </>
          ) : (
            <>
              <FaSave />
              <span>Save &amp; Issue Certificates 🚀</span>
            </>
          )}
        </button> */}
        <button 
  onClick={() => {
    if (isPlanExpired) {
      alert(getLockMessage());
      return;
    }
    handleSaveTemplate();
  }} 
  disabled={isIssuing || isPlanExpired} 
  className="btn text-white fw-bold d-flex align-items-center gap-2 px-4" 
  style={{ 
    backgroundColor: (isIssuing || isPlanExpired) ? '#94a3b8' : '#f35018', 
    borderRadius: '10px', 
    fontSize: '13px', 
    border: 'none', 
    cursor: (isIssuing || isPlanExpired) ? 'not-allowed' : 'pointer',
    opacity: isPlanExpired ? 0.65 : 1
  }}
  title={isPlanExpired ? getLockMessage() : "Save & Issue"}
>
  {isIssuing ? (
    <>
      <div className="spinner-border spinner-border-sm text-light" role="status"></div>
      <span>Issuing Certificates...</span>
    </>
  ) : isPlanExpired ? (
    <>
      <span>🔒 Plan Expired</span>
    </>
  ) : (
    <>
      <FaSave />
      <span>Save &amp; Issue Certificates 🚀</span>
    </>
  )}
</button>
      </div>

      {/* MASTER TWO-COLUMN CONTENT GRID */}
      <div className="flex-grow-1 row g-0">
        
        {/* LEFT CONTROL SIDEBAR PANEL */}
        <div className="col-12 col-lg-4 bg-white p-4 shadow-sm" style={{ maxHeight: 'calc(100vh - 70px)', overflowY: 'auto', borderRight: '1px solid rgba(47, 49, 148, 0.08)' }}>
          
          {/* SECTION 1: EVENT & SESSION SCOPE */}
          <div className="mb-4">
            <label className="form-label small fw-bold text-uppercase text-muted tracking-wide mb-1">
              1. Target Event
            </label>
            <select 
              className="form-select mb-3" 
              style={{ borderRadius: '8px', fontSize: '13px' }}
              value={selectedEventId}
              onChange={handleSelectEvent}
            >
              <option value="">-- Choose Event Scope --</option>
              {eventsList.map((ev) => (
                <option key={ev.id} value={ev.id}>{ev.name} (ID: #{ev.id})</option>
              ))}
            </select>

            <label className="form-label small fw-bold text-uppercase text-muted tracking-wide mb-1">
              2. Target Match Session ({sessionsList.length})
            </label>
            {/* {sessionsList.length === 0 ? (
              <div className="p-3 text-center border rounded-3 bg-light text-muted small">
                No recorded match sessions found for this event.
              </div>
            ) : (
              <div className="d-flex flex-column gap-2" style={{ maxHeight: '160px', overflowY: 'auto' }}>
                {sessionsList.map((s) => {
                  const isSelected = selectedRoomPin === String(s.room_pin);
                  const { date, time } = formatSessionDate(s.created_at);
                  return (
                    <div 
                      key={s.id}
                      onClick={() => setSelectedRoomPin(String(s.room_pin))}
                      style={{
                        padding: '10px 14px',
                        borderRadius: '10px',
                        border: isSelected ? '2px solid #f35018' : '1px solid #e2e8f0',
                        backgroundColor: isSelected ? '#fffaf8' : '#fafbfc',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <div>
                        <span style={{ fontSize: '12px', fontWeight: '700', color: isSelected ? '#f35018' : '#0f1137', display: 'block' }}>
                          PIN #{s.room_pin}
                        </span>
                        <small style={{ color: '#64748b', fontSize: '10px' }}>
                          <FaCalendarAlt style={{ marginRight: '4px' }} />{date} • {time}
                        </small>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <small style={{ fontWeight: '700', color: '#2f3194', fontSize: '11px' }}>
                          <FaUsers style={{ marginRight: '4px' }} />{s.total_participants || 0}
                        </small>
                        {isSelected && <FaCheckCircle color="#f35018" size={14} />}
                      </div>
                    </div>
                  );
                })}
              </div>
            )} */}
            {sessionsList.length === 0 ? (
              <div className="p-3 text-center border rounded-3 bg-light text-muted small">
                No recorded match sessions found for this event.
              </div>
            ) : (
              <div className="d-flex flex-column gap-2" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                {sessionsList.map((s) => {
                  const isSelected = selectedRoomPin === String(s.room_pin) && selectedSessionType === (s.session_type || 'live');
                  const isSelfPaced = s.session_type === 'self_paced';
                  const { date, time } = formatSessionDate(s.created_at);

                  return (
                    <div 
                      key={`${s.session_type || 'live'}-${s.id}`}
                      onClick={() => {
                        setSelectedRoomPin(String(s.room_pin));
                        setSelectedSessionType(s.session_type || 'live');
                      }}
                      style={{
                        padding: '10px 14px',
                        borderRadius: '10px',
                        border: isSelected ? '2px solid #f35018' : '1px solid #e2e8f0',
                        backgroundColor: isSelected ? (isSelfPaced ? '#f0f9ff' : '#fffaf8') : '#fafbfc',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        transition: 'all 0.15s ease'
                      }}
                    >
                      <div>
                        <div className="d-flex align-items-center gap-1.5 mb-1">
                          <span style={{ fontSize: '12px', fontWeight: '700', color: isSelected ? '#f35018' : '#0f1137' }}>
                            {isSelfPaced ? `CODE #${s.room_pin}` : `PIN #${s.room_pin}`}
                          </span>
                          <span style={{
                            fontSize: '9px',
                            fontWeight: '800',
                            padding: '1px 6px',
                            borderRadius: '4px',
                            backgroundColor: isSelfPaced ? 'rgba(2, 132, 199, 0.12)' : 'rgba(243, 80, 24, 0.12)',
                            color: isSelfPaced ? '#0284c7' : '#f35018',
                            textTransform: 'uppercase'
                          }}>
                            {isSelfPaced ? '⚡ Self-Paced' : '🎮 Live'}
                          </span>
                        </div>
                        <small style={{ color: '#64748b', fontSize: '10px' }}>
                          <FaCalendarAlt style={{ marginRight: '4px' }} />{date} {time}
                        </small>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <small style={{ fontWeight: '700', color: '#2f3194', fontSize: '11px' }}>
                          <FaUsers style={{ marginRight: '4px' }} />{s.total_participants || 0}
                        </small>
                        {isSelected && <FaCheckCircle color="#f35018" size={14} />}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <hr className="my-3" style={{ opacity: 0.08 }} />

          {/* SECTION 2: TEMPLATE LAYOUT THEME */}
          {/* <div className="mb-4">
            <label className="form-label small fw-bold text-uppercase text-muted tracking-wide d-flex align-items-center gap-2 mb-2">
              <FaPalette /> 3. Layout Style Theme
            </label>
            <div className="d-flex flex-wrap gap-2">
              {[
                { key: 'classic', label: 'Classic Gold' },
                { key: 'modern', label: 'Modern Navy' },
                { key: 'luxuryDark', label: 'Luxury Dark' },
                { key: 'quizifyBrand', label: 'Quizify Brand' }
              ].map(themeItem => (
                <button 
                  key={themeItem.key} 
                  type="button"
                  onClick={() => setSelectedTheme(themeItem.key)} 
                  className="btn py-2 fw-bold text-capitalize rounded-3 flex-grow-1" 
                  style={{
                    border: selectedTheme === themeItem.key ? '2px solid #2f3194' : '1px solid rgba(0,0,0,0.1)',
                    background: selectedTheme === themeItem.key ? 'rgba(47,49,148,0.05)' : '#fff',
                    color: selectedTheme === themeItem.key ? '#2f3194' : '#6c757d',
                    fontSize: '12px'
                  }}
                >
                  {themeItem.label}
                </button>
              ))}
            </div>
          </div> */}


          {/* SECTION 2: TEMPLATE LAYOUT THEME */}
<div className="mb-4">
  <div className="d-flex justify-content-between align-items-center mb-2">
    <label className="form-label small fw-bold text-uppercase text-muted tracking-wide d-flex align-items-center gap-2 m-0">
      <FaPalette /> 3. Layout Style Theme
    </label>
    <span 
      className="badge rounded-pill px-2.5 py-1"
      style={{ 
        fontSize: '11px',
        backgroundColor: isPlanExpired ? '#fee2e2' : 'rgba(47, 49, 148, 0.08)',
        color: isPlanExpired ? '#b91c1c' : '#2f3194',
        border: isPlanExpired ? '1px solid #fca5a5' : 'none'
      }}
    >
      {isPlanExpired 
        ? 'Plan Expired (0 Enabled)' 
        : `Available: ${allowedTemplateCount} of 4 Templates`}
    </span>
  </div>

  {/* Expired Plan Banner */}
  {isPlanExpired && (
    <div className="alert alert-danger py-2 px-3 small rounded-3 mb-3 d-flex justify-content-between align-items-center">
      <span>⚠️ {getLockMessage()}</span>
      <button 
        type="button" 
        onClick={() => navigate('/dashboard')} 
        className="btn btn-sm btn-danger fw-bold py-0 px-2"
        style={{ fontSize: '11px', borderRadius: '6px' }}
      >
        Upgrade
      </button>
    </div>
  )}

  <div className="d-flex flex-wrap gap-2">
    {[
      { key: 'classic', label: 'Classic Gold' },
      { key: 'modern', label: 'Modern Navy' },
      { key: 'luxuryDark', label: 'Luxury Dark' },
      { key: 'quizifyBrand', label: 'Quizify Brand' }
    ].map((themeItem, index) => {
      // Disabled if plan is expired OR index exceeds allowed count for this tier
      const isLocked = isPlanExpired || index >= allowedTemplateCount;

      return (
        <button 
          key={themeItem.key} 
          type="button"
          disabled={isLocked}
          onClick={() => setSelectedTheme(themeItem.key)} 
          className="btn py-2 fw-bold text-capitalize rounded-3 flex-grow-1 position-relative" 
          style={{
            border: selectedTheme === themeItem.key && !isLocked 
              ? '2px solid #2f3194' 
              : '1px solid rgba(0,0,0,0.1)',
            background: isLocked 
              ? '#f1f5f9' 
              : selectedTheme === themeItem.key 
              ? 'rgba(47,49,148,0.05)' 
              : '#fff',
            color: isLocked 
              ? '#94a3b8' 
              : selectedTheme === themeItem.key 
              ? '#2f3194' 
              : '#6c757d',
            fontSize: '12px',
            cursor: isLocked ? 'not-allowed' : 'pointer',
            opacity: isLocked ? 0.6 : 1
          }}
          title={isLocked ? (isPlanExpired ? getLockMessage() : `Upgrade your plan to unlock ${themeItem.label}`) : themeItem.label}
        >
          {isLocked && <span style={{ marginRight: '4px' }}>🔒</span>}
          {themeItem.label}
        </button>
      );
    })}
  </div>
</div>

<div className="mb-4 p-3 rounded-3 border bg-light">
            <label className="form-label small fw-bold text-dark d-block mb-1">
              🖼️ Certificate Watermark Background (Optional)
            </label>
            <div className="position-relative text-center border p-2 rounded-2 bg-white" style={{ borderStyle: 'dashed', cursor: 'pointer' }}>
              <input 
                type="file" 
                accept="image/*" 
                onChange={(e) => handleFileUploader(e, setBgImagePreview)} 
                className="position-absolute top-0 start-0 w-100 h-100 opacity-0" 
                style={{ cursor: 'pointer' }} 
              />
              <span className="small text-muted" style={{ fontSize: '11px' }}>
                {bgImagePreview ? '✓ Watermark Uploaded (Click to Change)' : '+ Upload Watermark Image'}
              </span>
            </div>

            {bgImagePreview && (
              <div className="mt-3">
                {/* Opacity Slider */}
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="small text-muted">Watermark Opacity:</span>
                  <strong>{Math.round(bgOpacity * 100)}%</strong>
                </div>
                <input 
                  type="range" 
                  className="form-range" 
                  min="0.05" 
                  max="0.60" 
                  step="0.02" 
                  value={bgOpacity} 
                  onChange={(e) => setBgOpacity(Number(e.target.value))} 
                />

                {/* Size Slider */}
                <div className="d-flex justify-content-between align-items-center mt-2 mb-1">
                  <span className="small text-muted">Watermark Size:</span>
                  <strong>{bgSize}px</strong>
                </div>
                <input 
                  type="range" 
                  className="form-range" 
                  min="300" 
                  max="800" 
                  step="20" 
                  value={bgSize} 
                  onChange={(e) => setBgSize(Number(e.target.value))} 
                />

                <div className="text-end mt-1">
                  <button 
                    type="button" 
                    onClick={() => setBgImagePreview(null)} 
                    className="btn btn-link text-danger p-0"
                    style={{ fontSize: '11px' }}
                  >
                    Remove Watermark
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* SECTION 3: HEADER ASSETS & EMBLEM */}
        <h6 className="fw-bold mb-3" style={{ color: '#2f3194', fontSize: '13px' }}>[STAGE 1] HEADER &amp; LOGO ASSETS</h6>
          
          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Organization Brand Logo</label>
            <div className="position-relative text-center border p-3 rounded-3" style={{ background: '#fafbfc', borderStyle: 'dashed', cursor: 'pointer' }}>
              <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setLogoPreview)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
              <FaCloudUploadAlt size={22} className="text-muted mb-1" />
              <span className="d-block small text-muted" style={{ fontSize: '11px' }}>
                {logoPreview ? 'Change Logo Image' : 'Select Image File'}
              </span>
            </div>
            
            {/* Logo Width Slider (Now scales up to 260px smoothly) */}
            {logoPreview && (
              <div className="mt-2 p-2 bg-light rounded border">
                <div className="d-flex justify-content-between small text-muted mb-1">
                  <span>Logo Width:</span>
                  <strong className="text-primary">{logoWidth}px</strong>
                </div>
                <input 
                  type="range" 
                  className="form-range" 
                  min="60" 
                  max="150" 
                  step="5"
                  value={logoWidth} 
                  onChange={(e) => setLogoWidth(Number(e.target.value))} 
                />
                <button 
                  type="button" 
                  onClick={() => setLogoPreview(null)} 
                  className="btn btn-link text-danger p-0 mt-1" 
                  style={{ fontSize: '11px' }}
                >
                  Remove Logo
                </button>
              </div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label small fw-bold text-uppercase text-muted tracking-wide mb-2">
              🏅 Header Seal Emblem
            </label>
            <div className="d-flex flex-wrap gap-1">
              {[
                { key: 'trophy', label: '🏆 Trophy' },
                { key: 'starShield', label: '⭐ Star' },
                { key: 'ribbon', label: '🏅 Medal' },
                { key: 'modernSeal', label: '👑 Crest' }
              ].map(badgeItem => (
                <button
                  key={badgeItem.key}
                  type="button"
                  onClick={() => setSelectedBadge(badgeItem.key)}
                  className="btn py-1.5 fw-bold rounded-3 flex-grow-1"
                  style={{
                    border: selectedBadge === badgeItem.key ? '2px solid #f35018' : '1px solid rgba(0,0,0,0.1)',
                    background: selectedBadge === badgeItem.key ? 'rgba(243,80,24,0.05)' : '#fff',
                    color: selectedBadge === badgeItem.key ? '#f35018' : '#6c757d',
                    fontSize: '11px'
                  }}
                >
                  {badgeItem.label}
                </button>
              ))}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Upper Header Heading</label>
            <input type="text" className="form-control" name="header" value={certData.header} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
          </div>

          <hr className="my-4" style={{ opacity: 0.08 }} />

          {/* SECTION 4: BODY COPY & EDITABLE PREFIX */}
          <h6 className="fw-bold mb-3" style={{ color: '#2f3194', fontSize: '13px' }}>[STAGE 2] MAIN BODY COPY</h6>

          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Presentation Title Phrase</label>
            <input type="text" className="form-control" name="title" value={certData.title} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
          </div>

          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Recipient Name (Preview Display)</label>
            <input type="text" className="form-control" name="recipientName" value={certData.recipientName} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px', fontWeight: 'bold' }} />
          </div>

          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Introductory Prefix Phrase</label>
            <input type="text" className="form-control" name="prefixText" value={certData.prefixText} onChange={handleTextChange} placeholder="e.g. For demonstrating exceptional proficiency in" style={{ borderRadius: '8px', fontSize: '13px' }} />
          </div>

          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Achievement Description Continuation</label>
            <textarea className="form-control" rows="2" name="achievementText" value={certData.achievementText} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px', lineHeight: '1.4' }} />
          </div>

          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Score / Placement Badge Text</label>
            <input type="text" className="form-control" name="scoreText" value={certData.scoreText} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
          </div>

          <hr className="my-4" style={{ opacity: 0.08 }} />

          {/* SECTION 5: FOOTER & SIGNATURES */}
      
{/* SECTION 5: FOOTER & 3 SIGNATURES */}
          <h6 className="fw-bold mb-3" style={{ color: '#2f3194', fontSize: '13px' }}>[STAGE 3] LOWER FOOTER &amp; SIGNATURES</h6>

          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">Date Issued Text</label>
            <input type="text" className="form-control" name="dateText" value={certData.dateText} onChange={handleTextChange} style={{ borderRadius: '8px', fontSize: '13px' }} />
          </div>

          {/* SIGNATURE 1 */}
    {/* SIGNER 1 */}
<div className="p-3 mb-3 border rounded-3 bg-light">
  <label className="form-label small fw-bold text-dark d-block mb-1">✍️ Signer 1 (Primary)</label>
  <input 
    type="text" 
    className="form-control mb-1" 
    name="signerName1" 
    placeholder="Signer Full Name (e.g. PID R. Mathanagopal)" 
    value={certData.signerName1} 
    onChange={handleTextChange} 
    style={{ fontSize: '12px' }} 
  />
  <input 
    type="text" 
    className="form-control mb-2" 
    name="footerTitle" 
    placeholder="Designation (e.g. Chairman & Editor)" 
    value={certData.footerTitle} 
    onChange={handleTextChange} 
    style={{ fontSize: '12px' }} 
  />
  <div className="row g-2">
    <div className="col-6">
      <div className="position-relative text-center border p-1 rounded bg-white" style={{ borderStyle: 'dashed' }}>
        <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setSig1Photo)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" />
        <span style={{ fontSize: '10px' }}>{sig1Photo ? '✓ Photo Set' : '+ Photo'}</span>
      </div>
      {sig1Photo && <button type="button" onClick={() => setSig1Photo(null)} className="btn btn-link text-danger p-0" style={{ fontSize: '10px' }}>Remove</button>}
    </div>
    <div className="col-6">
      <div className="position-relative text-center border p-1 rounded bg-white" style={{ borderStyle: 'dashed' }}>
        <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setSig1Preview)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" />
        <span style={{ fontSize: '10px' }}>{sig1Preview ? '✓ Sig Set' : '+ Signature'}</span>
      </div>
      {sig1Preview && <button type="button" onClick={() => setSig1Preview(null)} className="btn btn-link text-danger p-0" style={{ fontSize: '10px' }}>Remove</button>}
    </div>
  </div>
</div>

{/* SIGNER 2 (REPEAT THE SAME PATTERN FOR SIGNER 2 & 3 WITH sig2Photo, sig2Preview, signerName2, footerTitle2) */}

          {/* SIGNER 2 */}
       {/* SIGNATURE 2 (OPTIONAL) */}
<div className="p-3 mb-3 border rounded-3 bg-light">
  <label className="form-label small fw-bold text-dark d-block mb-1">✍️ Signer 2 (Optional)</label>
  <input 
    type="text" 
    className="form-control mb-1" 
    name="signerName2" 
    placeholder="Signer 2 Name (e.g. Dr. A. Sharma)" 
    value={certData.signerName2} 
    onChange={handleTextChange} 
    style={{ fontSize: '12px' }} 
  />
  <input 
    type="text" 
    className="form-control mb-2" 
    name="footerTitle2" 
    placeholder="Designation (e.g. Co-ordinator)" 
    value={certData.footerTitle2} 
    onChange={handleTextChange} 
    style={{ fontSize: '12px' }} 
  />
  <div className="row g-2">
    <div className="col-6">
      <div className="position-relative text-center border p-1 rounded bg-white" style={{ borderStyle: 'dashed', cursor: 'pointer' }}>
        <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setSig2Photo)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
        <span style={{ fontSize: '10px' }}>{sig2Photo ? '✓ Photo Set' : '+ Photo'}</span>
      </div>
      {sig2Photo && <button type="button" onClick={() => setSig2Photo(null)} className="btn btn-link text-danger p-0" style={{ fontSize: '10px' }}>Remove</button>}
    </div>
    <div className="col-6">
      <div className="position-relative text-center border p-1 rounded bg-white" style={{ borderStyle: 'dashed', cursor: 'pointer' }}>
        <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setSig2Preview)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
        <span style={{ fontSize: '10px' }}>{sig2Preview ? '✓ Sig Set' : '+ Signature'}</span>
      </div>
      {sig2Preview && <button type="button" onClick={() => setSig2Preview(null)} className="btn btn-link text-danger p-0" style={{ fontSize: '10px' }}>Remove</button>}
    </div>
  </div>
</div>

          {/* SIGNER 3 */}
          {/* SIGNATURE 3 (OPTIONAL) */}
<div className="p-3 mb-3 border rounded-3 bg-light">
  <label className="form-label small fw-bold text-dark d-block mb-1">✍️ Signer 3 (Optional)</label>
  <input 
    type="text" 
    className="form-control mb-1" 
    name="signerName3" 
    placeholder="Signer 3 Name (e.g. Director / Principal)" 
    value={certData.signerName3} 
    onChange={handleTextChange} 
    style={{ fontSize: '12px' }} 
  />
  <input 
    type="text" 
    className="form-control mb-2" 
    name="footerTitle3" 
    placeholder="Designation (e.g. Head Examiner)" 
    value={certData.footerTitle3} 
    onChange={handleTextChange} 
    style={{ fontSize: '12px' }} 
  />
  <div className="row g-2">
    <div className="col-6">
      <div className="position-relative text-center border p-1 rounded bg-white" style={{ borderStyle: 'dashed', cursor: 'pointer' }}>
        <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setSig3Photo)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
        <span style={{ fontSize: '10px' }}>{sig3Photo ? '✓ Photo Set' : '+ Photo'}</span>
      </div>
      {sig3Photo && <button type="button" onClick={() => setSig3Photo(null)} className="btn btn-link text-danger p-0" style={{ fontSize: '10px' }}>Remove</button>}
    </div>
    <div className="col-6">
      <div className="position-relative text-center border p-1 rounded bg-white" style={{ borderStyle: 'dashed', cursor: 'pointer' }}>
        <input type="file" accept="image/*" onChange={(e) => handleFileUploader(e, setSig3Preview)} className="position-absolute top-0 start-0 w-100 h-100 opacity-0" style={{ cursor: 'pointer' }} />
        <span style={{ fontSize: '10px' }}>{sig3Preview ? '✓ Sig Set' : '+ Signature'}</span>
      </div>
      {sig3Preview && <button type="button" onClick={() => setSig3Preview(null)} className="btn btn-link text-danger p-0" style={{ fontSize: '10px' }}>Remove</button>}
    </div>
  </div>
</div>

        </div>
         



        {/* RIGHT LIVE CANVAS ARTBOARD DISPLAY */}
        <div className="col-12 col-lg-8 d-flex align-items-center justify-content-center p-4" style={{ background: '#eef0fa', overflowX: 'auto' }}>
          
          <div className="shadow-2xl position-relative p-5 animate-fade-in" style={{
            width: '840px',
            height: '595px', 
            background: activeStyle.background,
            border: activeStyle.border,
            fontFamily: activeStyle.fontFamily,
            boxShadow: '0 30px 60px rgba(15, 17, 55, 0.12)',
            transition: 'all 0.4s ease',
            boxSizing: 'border-box',
            color: activeStyle.textColor
          }}>

          {bgImagePreview && (
              <div 
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: `${bgSize}px`,
                  height: `${bgSize}px`,
                  backgroundImage: `url(${bgImagePreview})`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  opacity: bgOpacity,
                  pointerEvents: 'none',
                  zIndex: 0
                }}
              />
            )}
            
            {/* Graphic Corner Accents */}
            <div style={{ position: 'absolute', top: '20px', left: '20px', width: '40px', height: '40px', borderTop: `3px solid ${activeStyle.accentColor}`, borderLeft: `3px solid ${activeStyle.accentColor}` }} />
            <div style={{ position: 'absolute', bottom: '20px', right: '20px', width: '40px', height: '40px', borderBottom: `3px solid ${activeStyle.accentColor}`, borderRight: `3px solid ${activeStyle.accentColor}` }} />

            {/* Top Decorative Band */}
            <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '220px', height: '18px', background: activeStyle.accentColor, borderRadius: '0 0 12px 12px', opacity: 0.85 }} />

            {/* Header Row */}
   {/* Header Row */}
<div className="position-relative d-flex justify-content-between align-items-center mb-2" style={{ minHeight: '65px' }}>
  {/* Fixed-width left anchor box so increasing size never pushes right */}
  <div style={{ width: '260px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', zIndex: 2 }}>
    {logoPreview ? (
      <img 
        src={logoPreview} 
        alt="Logo" 
        style={{ 
          width: `${logoWidth}px`, 
          height: 'auto', 
          maxHeight: '85px', 
          objectFit: 'contain', 
          objectPosition: 'left center' 
        }} 
      />
    ) : (
      <div className="border rounded d-flex align-items-center justify-content-center text-muted" style={{ width: '45px', height: '35px', background: 'rgba(56, 56, 56, 0.02)', borderStyle: 'dashed', fontSize: '9px' }}>
        Logo
      </div>
    )}
  </div>

              {/* Centered Crest Badge */}
              <div className="position-absolute d-flex flex-column align-items-center justify-content-center shadow-sm" style={{ 
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                background: '#ffffff', 
                border: `2px solid ${activeStyle.accentColor}`, 
                borderRadius: '50%', 
                width: '52px', 
                height: '52px', 
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                zIndex: 1
              }}>
                <span style={{ fontSize: '24px', lineHeight: '1' }}>
                  {selectedBadge === 'trophy' && '🏆'}
                  {selectedBadge === 'starShield' && '⭐'}
                  {selectedBadge === 'ribbon' && '🏅'}
                  {selectedBadge === 'modernSeal' && '👑'}
                </span>
              </div>

              <div style={{ fontSize: '11px', fontWeight: 'bold', color: activeStyle.accentColor, letterSpacing: '0.5px', zIndex: 2 }}>
                SECURE VERIFIED CREDENTIAL
              </div>
            </div>

            {/* Main Body Typography */}
            <div className="text-center mt-3">
              <h2 className="fw-bold tracking-wide mb-1" style={{ color: activeStyle.accentColor, fontSize: '23px', textTransform: 'uppercase' }}>
                {certData.header}
              </h2>
              <h6 className="tracking-widest mb-3 fw-bold opacity-75" style={{ fontSize: '11px', letterSpacing: '2px', color: activeStyle.textColor }}>
                {certData.title}
              </h6>
              
              <h1 className="my-2 style-italic fw-extrabold" style={{ fontStyle: 'italic', fontSize: '40px', borderBottom: `2px solid ${activeStyle.accentColor}`, display: 'inline-block', padding: '0 30px', color: activeStyle.textColor }}>
                {certData.recipientName}
              </h1>

              <p className="mx-auto mt-3 opacity-90" style={{ fontSize: '14px', maxWidth: '640px', lineHeight: '1.6', color: activeStyle.textColor }}>
                {certData.prefixText} <strong style={{ color: activeStyle.accentColor }}>{selectedEventName}</strong> {certData.achievementText}
              </p>

              <div className="mt-2 px-4 py-1.5 rounded-pill fw-bold" style={{ 
                background: selectedTheme === 'luxuryDark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.03)', 
                border: `1px solid ${activeStyle.accentColor}`,
                display: 'inline-block', 
                fontSize: '13px', 
                color: activeStyle.textColor
              }}>
                {certData.scoreText}
              </div>
            </div>

            {/* Footer Row */}
            <div className="position-absolute bottom-0 start-0 w-100 px-5 d-flex align-items-end justify-content-between" style={{ marginBottom: selectedTheme === 'quizifyBrand' || activeStyle.showPromo ? '52px' : '38px' }}>
              
              <div className="text-center" style={{ width: '220px' }}>
                <span className="d-block border-bottom pb-1 fw-bold" style={{ fontSize: '14px', color: activeStyle.textColor, borderColor: 'rgba(0,0,0,0.15)' }}>
                  {certData.dateText}
                </span>
                <small className="d-block mt-1 fw-bold opacity-60" style={{ fontSize: '9px', letterSpacing: '0.5px' }}>
                  DATE ISSUED
                </small>
              </div>
              
              {/* Rosette Ribbon */}
              <div className="d-flex justify-content-center align-items-center" style={{ width: '120px', height: '110px', marginBottom: '-12px' }}>
                <div className="position-relative" style={{ width: '80px', height: '110px' }}>
                  <div style={{
                    position: 'absolute',
                    bottom: '4px',
                    left: '12px',
                    width: '24px',
                    height: '62px',
                    background: `linear-gradient(90deg, ${activeStyle.badgeRibbonColor} 0%, rgba(0,0,0,0.22) 100%)`,
                    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 50% 82%, 0% 100%)',
                    transform: 'rotate(7deg)',
                    border: '1px solid rgba(255,255,255,0.15)'
                  }} />
                  <div style={{
                    position: 'absolute',
                    bottom: '4px',
                    right: '12px',
                    width: '24px',
                    height: '62px',
                    background: `linear-gradient(90deg, rgba(0,0,0,0.22) 0%, ${activeStyle.badgeRibbonColor} 100%)`,
                    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 50% 82%, 0% 100%)',
                    transform: 'rotate(-7deg)',
                    border: '1px solid rgba(255,255,255,0.15)'
                  }} />
                  <div className="shadow-lg" style={{
                    position: 'absolute',
                    top: 0,
                    left: '4px',
                    width: '72px',
                    height: '72px',
                    borderRadius: '50%',
                    background: activeStyle.badgeRibbonColor,
                    border: '3px dotted rgba(255,255,255,0.38)',
                    boxShadow: '0 6px 14px rgba(0,0,0,0.22)'
                  }} />
                  <div className="d-flex align-items-center justify-content-center" style={{
                    position: 'absolute',
                    top: '7px',
                    left: '11px',
                    width: '58px',
                    height: '58px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #ffe066 0%, #d4af37 40%, #aa7c11 70%, #ffe066 100%)',
                    border: '2px solid #ffffff',
                    boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.28)'
                  }}>
                    <span style={{ fontSize: '20px' }}>🏅</span>
                  </div>
                </div>
              </div>

              <div className="text-center" style={{ width: '220px' }}>
               {/* Replace the single signature container with this flexible multi-signature layout */}
      {/* Footer Row Right Signatures Container */}
    <div className="d-flex align-items-end justify-content-end gap-3" style={{ maxWidth: '480px' }}>
  {[
    { photo: sig1Photo, sig: sig1Preview, name: certData.signerName1, designation: certData.footerTitle },
    { photo: sig2Photo, sig: sig2Preview, name: certData.signerName2, designation: certData.footerTitle2 },
    { photo: sig3Photo, sig: sig3Preview, name: certData.signerName3, designation: certData.footerTitle3 }
  ].filter(s => s.photo || s.sig || s.name || s.designation).map((s, idx) => (
    <div key={idx} style={{ textAlign: 'center', minWidth: '100px', maxWidth: '145px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {s.photo && (
        <img 
          src={s.photo} 
          alt="Signer Photo" 
          style={{ width: '64px', height: '64px', borderRadius: '50%', objectFit: 'cover', border: `1.5px solid ${activeStyle.accentColor}`, marginBottom: '2px' }} 
        />
      )}
      <div style={{ height: '32px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', marginBottom: '2px' }}>
        {s.sig ? (
          <img src={s.sig} alt="Signature" style={{ maxHeight: '32px', maxWidth: '110px', objectFit: 'contain' }} />
        ) : (
          <span style={{ fontSize: '9px', fontStyle: 'italic', opacity: 0.5 }}>Signature</span>
        )}
      </div>
      <div style={{ borderTop: `1px solid ${activeStyle.accentColor}`, width: '100%', paddingTop: '2px' }}>
        {s.name && <div style={{ fontSize: '8.5px', fontWeight: '800', lineHeight: 1.1, textTransform: 'uppercase' }}>{s.name}</div>}
        {s.designation && <div style={{ fontSize: '7.5px', fontWeight: '600', opacity: 0.75, textTransform: 'uppercase' }}>{s.designation}</div>}
      </div>
    </div>
  ))}
</div>
              
              </div>

            </div>

            {/* Brand Promotional Bar */}
            {(selectedTheme === 'quizifyBrand' || activeStyle.showPromo) && (
              <div className="position-absolute bottom-0 start-0 w-100 text-center py-2" style={{ 
                background: 'linear-gradient(90deg, #0f1137 0%, #2f3194 100%)', 
                color: '#ffffff', 
                fontSize: '10px', 
                fontWeight: '600',
                letterSpacing: '0.5px',
                borderTop: '1px solid rgba(255,255,255,0.1)'
              }}>
                Powered &amp; Verified by <span style={{ color: '#63decc', fontWeight: '800' }}>Quizifyai.in</span> — Next-Gen AI Examination Arena Suite
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default CertificateDesigner;